import React, { Component } from "react";
import {
    Col,
    OverlayTrigger,
    Row,
    Table,
    Tooltip
} from "react-bootstrap"

// Requests
import { deletePayLevelRequest } from "api/payLevel";
import { fetchPayLevelsRequest } from "api/payLevel";
// Components
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";

class PayLevelTable extends Component {
    state = {
        data: null,
        error: null,
        loading: false
    };

    componentDidMount() {
        if (!this.state.data)
          this.fetchPayLevelData()
      }

    fetchPayLevelData(){
        this.setState({
          loading: true
        });

        fetchPayLevelsRequest(
          result => this.setState({data: result, error: null, loading: false}),
          error => this.setState({error: error.message, loading: false})
        )
    };
    
    deletePayLevel = (id) => {
        deletePayLevelRequest(
            id,
            result => this.fetchPayLevelData(),
            error =>
              this.setState({ error: "There was an error deleting instance" })
        );
    }

    render() {
        const { 
            data,
            loading
        } = this.state;

        const view = <Tooltip id="view_tooltip">View</Tooltip>;
        const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
        const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

        return (
            <div className="content">
                <Row>
                    <Col md={12}>
                        <Card
                            title="Pay Level Table"
                            category="List of pay levels entries to DB"
                            ctTableFullWidth
                            ctTableResponsive
                            content={
                            <div>
                                <CustomButtom className="table-top-btn btn-primary" onClick={() => this.props.goToCreateForm('pay-level')}>
                                    New Entry
                                </CustomButtom>
                                <Table striped hover>
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Area</th>
                                            <th>Sick Leave</th>
                                            <th>Vacation Leave</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { loading 
                                        ?   <td colSpan="7" style={{padding: "0"}}>
                                                <div className="loader"></div>
                                            </td> 
                                        : data && data.length > 0 
                                        ? data.map(instance => {
                                            return (
                                                <tr key={instance._id}>
                                                <td>{instance.payLevelName}</td>
                                                <td>{instance.area?.areaName || "N/A"}</td>
                                                <td>{instance.sickLeaveDays || 0} days</td>
                                                <td>{instance.vacationLeaveDays || 0} days</td>
                                                <td className="td-actions text-right">
                                                    <OverlayTrigger placement="top" overlay={view}>
                                                        <CustomButtom 
                                                            bsStyle="success" 
                                                            simple 
                                                            type="button" 
                                                            bsSize="xs"
                                                            onClick={() => this.props.goToDetails('pay-level', instance._id)}
                                                        >
                                                            <i className="fa fa-eye" />
                                                        </CustomButtom>
                                                    </OverlayTrigger>

                                                    <OverlayTrigger placement="top" overlay={edit}>
                                                        <CustomButtom 
                                                            bsStyle="info" 
                                                            simple 
                                                            type="button" 
                                                            bsSize="xs"
                                                            onClick={() => this.props.goToEditForm('pay-level', instance._id)}
                                                        >
                                                            <i className="fa fa-edit" />
                                                        </CustomButtom>
                                                    </OverlayTrigger>
                                                    <OverlayTrigger placement="top" overlay={remove}>
                                                        <CustomButtom 
                                                            bsStyle="danger" 
                                                            simple 
                                                            type="button" 
                                                            bsSize="xs"
                                                            onClick={() => this.deletePayLevel(instance._id)}
                                                        >
                                                            <i className="fa fa-times" />
                                                        </CustomButtom>
                                                    </OverlayTrigger> 
                                                </td>
                                                </tr>
                                            )}
                                            )
                                        : (
                                            <tr>
                                            <td colSpan='7'>There are no instances in the database yet.</td>
                                            </tr>
                                        )
                                        }
                                    </tbody>
                                </Table>
                            </div>
                            }
                        />
                    </Col>
                </Row>
            </div>
        )
    }

}

export default PayLevelTable;
